// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1RhmU","inputWrap":"styles_inputWrap__29PAS","input":"styles_input__IQiXv"};